import React, { Component } from "react";
import _ from "lodash";
import styled from "styled-components";
import * as Connection from "./../libs/connections";
import { PropTypes } from "prop-types";

import "../styles/components/SliderOurCars.css";

// import logo1 from "../assets/partners/logo-1.png";
// import logo2 from "../assets/partners/logo-2.png";
// import logo3 from "../assets/partners/logo-3.png";

const PartnersLogo = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 160px 0 230px;

  @media (max-width: 767.98px) {
    margin: 60px 0 60px;
  }

  div {
    display: flex;
    align-items: center;

    img {
      width: 100%;
    }
    &.logo-1 {
      max-width: 340px;
    }
    &.logo-2 {
      max-width: 350px;
    }
    &.logo-3 {
      max-width: 170px;
    }

    > * {
      max-width: 60%;
      margin-bottom: 30px;
    }
  }
`;

export default class OurPartners extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeElement: 0,
      error: false,
      componentTitle: "",
      elements: []
    };
  }

  async componentDidMount() {
    try {
      const response = await Connection.getAllCars(this.props.carCategory);
      this.setState({
        elements: response.slice(0, 6)
      });
    } catch (err) {
      this.setState({
        error: true
      });
    }
  }

  render() {
    const {
      paddingTop,
      paddingBottom,
      background,
      text,
      sectionNumber,
      elements
    } = this.props;

    return (
      <div
        className={`our-cars ${background ? "background" : ""}`}
        style={{
          paddingTop: paddingTop + "px",
          paddingBottom: paddingBottom + "px"
        }}
      >
        <div className="our-cars--header container container-small">
          <div className="row">
            <div className="col-12">
              <h5>
                <span>{sectionNumber}</span>
              </h5>
            </div>
            <div className="col-12 col-md-6">
              <h4>{text}</h4>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <PartnersLogo>
                <div className="logo-1">
                  <a
                    href="http://www.cbig.eu"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={_.get(elements, "[2].logo", "")}
                      alt="Logo Capital Brokers company"
                    />
                  </a>
                </div>
                <div className="logo-2">
                  <a
                    href="https://autoklinika-krakow.pl"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      className="logo-2"
                      src={_.get(elements, "[1].logo", "")}
                      alt="Logo Auto Klinika company"
                    />
                  </a>
                </div>
                <div className="logo-3">
                  <a
                    href="https://motomio.pl"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      className="logo-3"
                      src={_.get(elements, "[0].logo", "")}
                      alt="Logo Motomio company"
                    />
                  </a>
                </div>
              </PartnersLogo>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

OurPartners.propTypes = {
  paddingTop: PropTypes.number,
  text: PropTypes.string.isRequired,
  paddingBottom: PropTypes.number,
  sectionNumber: PropTypes.string.isRequired,
  carCategory: PropTypes.number,
  carId: PropTypes.number
};

OurPartners.defaultProps = {
  paddingTop: 0,
  paddingBottom: 0
};
